import { render, staticRenderFns } from "./SideBar.vue?vue&type=template&id=7ce0874e&"
import script from "./SideBar.vue?vue&type=script&lang=js&"
export * from "./SideBar.vue?vue&type=script&lang=js&"
import style0 from "./SideBar.vue?vue&type=style&index=0&id=7ce0874e&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ichigei/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ce0874e')) {
      api.createRecord('7ce0874e', component.options)
    } else {
      api.reload('7ce0874e', component.options)
    }
    module.hot.accept("./SideBar.vue?vue&type=template&id=7ce0874e&", function () {
      api.rerender('7ce0874e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Sidebar/SideBar.vue"
export default component.exports